import script from "./profitCalculationDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./profitCalculationDetail.vue?vue&type=script&setup=true&lang=js"

import "./profitCalculationDetail.vue?vue&type=style&index=0&id=10c9a0ac&lang=less"

const __exports__ = script;

export default __exports__